import { MobileConfiguratorFooter } from "./MobileConfiguratorFooter";
import { MobileConfiguratorHeader } from "./MobileConfiguratorHeader";
import MobileConfiguratorLayout from "./MobileConfiguratorLayout";
import { MobileConfiguratorProductScene } from "./MobileConfiguratorProductScene";
export const MobileConfigurator = () => {
  return (
    <div className="gg-max-h-[1050px] gg-bg-transparent">
      {/* Header */}
      <MobileConfiguratorHeader />

      {/* Product Scene + carousel */}

      <MobileConfiguratorProductScene />

      {/* <MobileConfiguratorProgressBar /> */}

      <MobileConfiguratorLayout />

      {/* Footer */}
      <MobileConfiguratorFooter />
    </div>
  );
};
